import { render, staticRenderFns } from "./bank-detail.vue?vue&type=template&id=084ab08e&scoped=true"
import script from "./bank-detail.vue?vue&type=script&lang=js"
export * from "./bank-detail.vue?vue&type=script&lang=js"
import style0 from "./bank-detail.vue?vue&type=style&index=0&id=084ab08e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084ab08e",
  null
  
)

export default component.exports